import React, { Component } from 'react';
import styles from './styles.css';
import ReactPlayer from "react-player";

function SilentDisco() {
    return (
    <div className= "section section-icons white lighten-4 center scrollspy">
      <ReactPlayer
        url="https://youtu.be/7bs0PaK8Fas"
      />
      <ReactPlayer
        url="https://youtu.be/FwLdnwZrd5Y"
      />
    </div>
    ) 
}


export default SilentDisco;



// WEBPACK FOOTER //
// ./src/pages/Secret/index.js